import { html } from 'lit';

export function defaultImageTemplate() {
  return html`
    <svg
      width="378"
      height="515"
      viewBox="0 0 378 515"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 12C0 5.37257 5.37258 0 12 0H365.466C372.093 0 377.466 5.37258 377.466 12V503C377.466 509.627 372.093 515 365.466 515H12C5.37259 515 0 509.627 0 503V12Z"
        fill="#EDF5FC"
      />
      <g clip-path="url(#clip0_4343_30749)">
        <path
          d="M189 226C182.671 226 176.484 227.877 171.222 231.393C165.959 234.909 161.858 239.907 159.436 245.754C157.014 251.601 156.38 258.035 157.615 264.243C158.85 270.45 161.897 276.152 166.373 280.627C170.848 285.103 176.55 288.15 182.757 289.385C188.965 290.62 195.399 289.986 201.246 287.564C207.093 285.142 212.091 281.041 215.607 275.778C219.123 270.516 221 264.329 221 258C221 249.513 217.629 241.374 211.627 235.373C205.626 229.371 197.487 226 189 226V226ZM181.72 271.68V258.204L187.587 265.36H190.253L196.351 258.249V271.68H202.387V279.52H175.569V271.68H181.72ZM210.164 255.68H202.431V249.52H196.387L188.911 258.258L181.8 249.52H175.551V255.689H167.871V240.889H210.129L210.164 255.68Z"
          fill="#CFE3FA"
        />
      </g>
      <defs>
        <clipPath id="clip0_4343_30749">
          <rect
            width="64"
            height="64"
            fill="white"
            transform="translate(157 226)"
          />
        </clipPath>
      </defs>
    </svg>
  `;
}

export function defaultImageTemplateSecond() {
  return html`
    <svg
      width="378"
      height="515"
      viewBox="0 0 378 515"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 12C0 5.37257 5.37258 0 12 0H365.466C372.093 0 377.466 5.37258 377.466 12V503C377.466 509.627 372.093 515 365.466 515H12C5.37259 515 0 509.627 0 503V12Z"
        fill="#428CEC"
      />
      <g clip-path="url(#clip0_4343_30749)">
        <path
          d="M189 226C182.671 226 176.484 227.877 171.222 231.393C165.959 234.909 161.858 239.907 159.436 245.754C157.014 251.601 156.38 258.035 157.615 264.243C158.85 270.45 161.897 276.152 166.373 280.627C170.848 285.103 176.55 288.15 182.757 289.385C188.965 290.62 195.399 289.986 201.246 287.564C207.093 285.142 212.091 281.041 215.607 275.778C219.123 270.516 221 264.329 221 258C221 249.513 217.629 241.374 211.627 235.373C205.626 229.371 197.487 226 189 226V226ZM181.72 271.68V258.204L187.587 265.36H190.253L196.351 258.249V271.68H202.387V279.52H175.569V271.68H181.72ZM210.164 255.68H202.431V249.52H196.387L188.911 258.258L181.8 249.52H175.551V255.689H167.871V240.889H210.129L210.164 255.68Z"
          fill="#FFFFFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_4343_30749">
          <rect
            width="64"
            height="64"
            fill="white"
            transform="translate(157 226)"
          />
        </clipPath>
      </defs>
    </svg>
  `;
}

/**
 * Transforms the Yext image URL to the desired format
 * @param url Original Yext image URL
 * @param height Desired image height
 * @param width Desired image width
 * @returns Transformed image URL
 */
export function transformImageUrl(
  url: string,
  height: number,
  width: number
): string {
  if (!url) return '';

  // Extract the image identifier from the original URL
  const matches = url.match(/p\/(.*?)\//);
  if (!matches || !matches[1]) return url;

  const imageId = matches[1];
  const params = `height=${height},width=${width},fit=crop,gravity=top,format=avif`;

  return `https://dyn.mktgcdn.com/p/${imageId}/${params}`;
}
